import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=4281e9a4&scoped=true"
import script from "./BannerSwiper.vue?vue&type=script&lang=js"
export * from "./BannerSwiper.vue?vue&type=script&lang=js"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&id=4281e9a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4281e9a4",
  null
  
)

export default component.exports